export const MESSAGES = {
  REVIEW_DELETE_MODAL: {
    TITLE: 'Delete Review',
    DESCRIPTION:
      'Are you sure you want to delete this review? This action cannot be undone.',
    DELETE_SUCCESS_MSG: 'Review was successfully deleted',
    SUCCESS_ACTION: 'Delete',
  },
  POINT_DELETE_MODAL: {
    TITLE: 'Delete Place',
    DESCRIPTION:
      'Are you sure you want to delete this place? This action cannot be undone.',
    DELETE_SUCCESS_MSG: 'Place was successfully deleted',
    SUCCESS_ACTION: 'Delete',
  },
  EVENT_DELETE_MODAL: {
    TITLE: 'Delete Event',
    DESCRIPTION:
      'Are you sure you want to delete this event? This action cannot be undone.',
    DELETE_SUCCESS_MSG: 'Event was successfully deleted',
    SUCCESS_ACTION: 'Delete',
  },
  POINT_EDIT_MODAL: {
    TITLE: 'Are you sure you want to leave?',
    DESCRIPTION:
      'If you leave now, your changes will not be saved. This action cannot be undone.',
    EDIT_SUCCESS_MSG: 'Place was successfully updated',
    SUCCESS_ACTION: 'Leave',
  },
  POINT_CREATE_MODAL: {
    TITLE: 'Are you sure you want to leave?',
    DESCRIPTION:
      'If you leave now, your changes will not be saved. This action cannot be undone.',
    CREATE_SUCCESS_MSG: 'Place was successfully created',
    SUCCESS_ACTION: 'Leave',
  },
  POINT_DELETE_IS_NOT_POSSIBLE_MODAL: {
    TITLE: "Place can't be deleted",
    DESCRIPTION: "A place with other users' reviews can't be deleted.",
    ACTION: 'Close',
  },
  POINT_DUPLICATE_MODAL: {
    TITLE: 'Save Place',
    DESCRIPTION:
      'A place in this location with the same name already exists. Are you sure you want to create another one?',
    SUCCESS_MSG: 'Place was successfully created',
    SUCCESS_ACTION: 'Create',
  },
}
